<template>
<div ref="element" class="hoverable-image-wrapper">
  <img @click="handleHoverMobile" v-for="src in sources" :src="src"></img>
</div>
</template>

<script>
import lazyImage from '@/components/layout/_lazyImage.vue';

export default {
  name: 'hoverableImage',
  data() {
    return {
      hoverMobile: false
    }
  },
  props: {
    sources: {
      type: Array,
      default: []
    },
  },
  computed: {
    isMobile() {
      return this.$root.isMobile
    }
  },
  components: {
    lazyImage
  },
  methods: {
    handleHoverMobile() {
      if (!this.isMobile) {
        return
      }
      this.hoverMobile = !this.hoverMobile;
      if (this.hoverMobile) {

        this.$refs.element.classList.add('mobile-hover')
        this.$refs.element.classList.remove('mobile-hover-out')
      } else {
        this.$refs.element.classList.add('mobile-hover-out')
        this.$refs.element.classList.remove('mobile-hover')

      }
    }
  }

}
</script>

<style lang="scss">
.hoverable-image-wrapper {
    position: relative;
    img:first-child {
        position: absolute;
        transition: opacity 0.3s ease;
        opacity: 0;
    }
    img:first-child:hover {

        opacity: 1;
    }
    &.mobile-hover img:first-child {
        opacity: 1;
    }
    &.mobile-hover-out img:first-child {
        opacity: 0 !important;
    }
}
</style>
